import dayjs from "dayjs";
import { DATE_FORMAT } from "../config/constants";
import { msToTime } from "./getHoursDiff";

export const dateFormatterNth = (date: string | Date) => {
  return dayjs(date).format("Do MMM YYYY");
};

export const dateFormatter = (date: string) => {
  return dayjs(date).format("DD MMM YYYY");
};

export const dateDisplay = (
  dateToConvert: Date | string,
  shortForm = false,
  startingDate?: Date | string
) => {
  if (!dateToConvert) return;

  const now = new Date();
  const date = new Date(`${dateToConvert}`);
  const startingConverted = new Date(`${startingDate}`);

  const diff = startingDate
    ? startingConverted.getTime() - date.getTime()
    : now.getTime() - date.getTime();

  if (diff < 0) return "N/A";

  const { seconds, minutes, hours, days } = msToTime(diff);

  if (days > 7 && !startingDate) {
    return dateFormatterNth(dateToConvert);
  } else if (days) {
    return `${days} ${days <= 1 ? "day" : "days"} ${
      !startingDate ? " ago" : ""
    }`;
  } else if (hours) {
    return `${hours} ${hours <= 1 ? "hour" : shortForm ? "hrs" : "hours"} ${
      !startingDate ? " ago" : ""
    }`;
  } else if (minutes) {
    return `${minutes} ${
      minutes <= 1 ? "minute" : shortForm ? "mins" : "minutes"
    } ${!startingDate ? " ago" : ""}`;
  } else if (seconds) {
    return `${seconds} ${
      seconds <= 1 ? "second" : shortForm ? "secs" : "seconds"
    } ${!startingDate ? " ago" : ""}`;
  }
};

export const getHoursFromDate = (date: Date | string) => {
  if (!date) {
    return { hours: "", minutes: "", seconds: "" };
  }

  return {
    hours: new Date(date).getHours(),
    minutes: new Date(date).getMinutes(),
    seconds: new Date(date).getSeconds()
  };
};

export const subtractHours = ({
  date,
  hours
}: {
  date: Date | null;
  hours: number;
}) => {
  date && date.setHours(date.getHours() - hours);

  const fromNow = new Date();

  fromNow.setHours(fromNow.getHours() - hours);

  return date || fromNow;
};

export const combineDateAndTime = ({
  date,
  time
}: {
  date: string;
  time: string;
}) => {
  const dateTime = new Date(
    `${dayjs(date).format(DATE_FORMAT.yearDateFormat)}T${dayjs(time).format(
      DATE_FORMAT.clock
    )}`
  );
  return dateTime ? dateTime.toISOString() : "";
};
